<template>
  <div>
    <div class="nav">
      <div class="container-xl d-flex">
        <div class="nav-brand">
          <img
            src="@/assets/logo.png"
            alt="Ceara"
          >
        </div>
        <div>
          <div class="nav-user">
            <template v-if="$store.state.user.host">
              <span class="nav-user-name">{{ $store.state.user.name }}</span>
              <span
                class="nav-user-name"
                :class="agency.color"
                v-if="$store.state.user.host != agency.id"
              >COMO, {{ agency.name }}</span>
              <btn
                class="btn-lgrey px-4"
                @click="$store.dispatch('user/LOGOUT')"
              >
                SALIR
              </btn>
              <btn
                class="btn-lgrey"
                @click="$store.dispatch('user/HOST')"
              >
                GESTIONAR AGENCIA
              </btn>
            </template>
            <template
              v-else
              class="h-2"
            >
              <span class="nav-user-name">Hola, <strong>{{ agency.name }}</strong></span>
              <btn
                class="btn-lgrey px-4"
                @click="$store.dispatch('user/LOGOUT')"
              >
                SALIR
              </btn>
            </template>
          </div>
          <div class="nav-session">
            <span>{{ agency.address }}</span>
            <span class="ico ico-date ico-lg">{{ date }}</span>
            <span class="ico ico-time ico-lg">{{ time }}</span>
          </div>
        </div>
      </div>
    </div>
    <ul class="menu container-xl">
      <li>
        <router-link
          class="menu-link _grupales"
          :to="{ name: 'departures' }"
        >
          SALIDAS GRUPALES
        </router-link>
      </li>
      <li>
        <router-link
          class="menu-link _online"
          :to="{ name: 'reservations' }"
          title="PROXIMAMENTE"
        >
          MIS RESERVAS
        </router-link>
      </li>
      <li>
        <router-link
          class="menu-link _preview"
          :to="{ name: 'previews' }"
        >
          AVANCES
        </router-link>
      </li>
      <li>
        <a
          class="menu-link _itinerarios"
          href="http://cearaevt.tur.ar/itinerarios"
          target="_blank"
        ><span>VER ITINERARIOS</span></a>
      </li>
      <li>
        <a
          class="menu-link _pagos"
          href="http://cearaevt.tur.ar/shop/variable/"
          target="_blank"
        ><span>PAGOS ONLINE</span></a>
      </li>
      <!-- <li><span class="">ACCESO APLINK</span></li> -->
      <li>
        <a
          class="menu-link _contacto"
          href="http://cearaevt.tur.ar/contacto"
          target="_blank"
        ><span>CONTACTO</span></a>
      </li>
    </ul>
  </div>
</template>

<script>
import Btn from './Btn.vue'

var week = ['DOM', 'LUN', 'MAR', 'MIER', 'JUE', 'VIE', 'SAB']
var year = ['ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO', 'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE']

function padding0 (num, digit) {
  var zero = ''
  for (var i = 0; i < digit; i++) {
    zero += '0'
  }
  return (zero + num).slice(-digit)
}

export default {
  components: { Btn },

  computed: {
    agency () {
      return this.$store.state.user.agency
    }
  },

  data () {
    return {
      guest: this.$store.state.user,
      time: '',
      date: ''
    }
  },

  watch: {
    guest (a) {
      this.$store.dispatch('HOST', a)
    }
  },

  methods: {
    updateTime () {
      var cd = new Date()
      this.time = padding0(cd.getHours(), 2) + ':' + padding0(cd.getMinutes(), 2) + ':' + padding0(cd.getSeconds(), 2)
      this.date = week[cd.getDay()] + ', ' + padding0(cd.getDate(), 2) + ' ' + year[cd.getMonth()] + ' ' + padding0(cd.getFullYear(), 4)
    }
  },

  created () {
    this.updateTime()

    setInterval(this.updateTime, 1000)
  }
}
</script>
